import React from 'react'
// import smartImg from "../../../assets/Smart_Formats.webp"
import smartImg from "../../../assets/startNew.jpg"
import digitalImg from "../../../assets/web image.PNG"
import { Link } from 'react-router-dom'

const ExploreSmartFormats = () => {
    const options = [
        {
            id: 1,
            name: "AR-QR Codes",
            description: 'Fans love to keep physical products that have value and help them remember the moment. AR-QR codes only work with the physical product and up to 5 images +videos can be connected to one (1) AR-QR code.',
            img: smartImg
        },
        {
            id: 2,
            name: "Custom Integrations: Branded App, SDK, Backend CMS",
            description: 'Use Interactive’s technology to add an image scanner into your existing mobile app. Or have us create a full branded app white labeled to your brand or event name. ',
            img: digitalImg
        }
    ]

    const [currentOption, setCurrentOption] = React.useState(options[0])
    return (
        <div className='explore-smart-formats pt-[150px] pb-[100px]'>
            <div className="container mx-auto">
                <div className="flex lg:flex-row flex-col justify-between items-start gap-[40px] lg:gap-[100px]">
                    <div className="left lg:w-[60%] w-full">
                        <h2 className='text-[40px] font-bold' style={{ lineHeight: '1.2' }}>
                        Explore our Mixed Reality  <span className='besley font-normal italic'>Ai formats </span> that unlock exclusive content with your phone  <span className='besley font-normal italic'>camera</span>
                        </h2>
                        <hr className='my-6' />

                        <div className="options">
                            {
                                options.map(option => (
                                    <div key={option.id} className='option relative cursor-pointer' onClick={() => setCurrentOption(option)}>
                                        <div className="flex mt-8 justify-between items-start gap-2">
                                            <h3 className={`text-[24px] ${currentOption.id === option.id ? "italic besley font-normal" : "font-semibold"}`}>{option.name}</h3>
                                            {
                                                currentOption.id === option.id && (
                                                    <Link to='/contact' className='text-black block min-w-[150px] mt-2 text-right border-0 underline rounded-[6px] font-semibold'>
                                                        Request Demo
                                                    </Link>
                                                )
                                            }
                                        </div>
                                        {
                                            currentOption.id === option.id && (
                                                <p className='text-lg mt-4'>{option.description}</p>
                                            )
                                        }
                                        <div className="mt-4"></div>
                                    </div>
                                ))
                            }
                        </div>

                    </div>
                    <div className="right w-full lg:w-[40%]">
                        <div className="card border border-black p-5">
                            <img src={currentOption.img} alt="" className='mb-5' />
                            <Link to='/contact' className='text-white w-full block text-center bg-black border-0 uppercase px-4 py-3 rounded-[6px] font-semibold'>
                            Request Demo
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExploreSmartFormats
